import React from "react";
import { PlainLink, Body } from "@components";
import locale from "@bonliva-crm/locale";

type Value = { _id: string; Name?: string };

const ConsultantLink = ({ _id, Name }: Value) => (
  <PlainLink href={`/consultants/${_id}`} target="_blank" inline>
    {Name}
  </PlainLink>
);

const generateEmailWarning = (x, value) => (
  <Body>
    {locale.SimilarEmailAlreadyAssigned(value)}
    <ConsultantLink {...x} />
  </Body>
);

const generateBlacklistError = (date) => <Body>{locale.BlacklistExist(date)}</Body>;

const EmailError = (x, value) => (
  <Body>
    {locale.Consultant}&nbsp;
    <ConsultantLink {...x} />
    &nbsp;
    {locale.EmailAlreadyAssigned(value)}
  </Body>
);

type Props = {
  data: any;
};

export function FormMessages(props: Props) {
  const mainStyle = { margin: "14px 14px 0" };
  const titleStyle = { marginBottom: "7px" };

  let body = null;

  if (props.data.duplicate) {
    body = EmailError(props.data.duplicate, props.data.duplicate.Email);
  } else {
    if (props.data.blackList) {
      body = generateBlacklistError(props.data.blackList.Date);
    } else {
      if (props.data.similar) {
        body = generateEmailWarning(props.data.similar, props.data.similar.Email);
      } else {
        return null;
      }
    }
  }

  return (
    <div style={mainStyle}>
      <Body style={titleStyle} color="error" block>
        {locale.FormCannotBeSaved}
      </Body>
      <div>{body}</div>
    </div>
  );
}
